var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCatalogProducts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M16.455,24H1.545A1.548,1.548,0,0,1,0,22.453V21.7H.818a.568.568,0,0,0,0-1.137H0V18.654H.818a.569.569,0,0,0,0-1.138H0V15.605H.818a.562.562,0,0,0,.568-.568.581.581,0,0,0-.568-.591H0V12.558H.818a.581.581,0,0,0,.568-.592A.562.562,0,0,0,.818,11.4H0V9.509H.818a.581.581,0,0,0,.568-.591.562.562,0,0,0-.568-.568H0V6.439H.818a.569.569,0,0,0,0-1.138H0V3.389H.818a.569.569,0,0,0,0-1.138H0v-.7A1.548,1.548,0,0,1,1.545,0H16.455A1.53,1.53,0,0,1,18,1.547V22.453A1.53,1.53,0,0,1,16.455,24ZM4.477,2.957A.764.764,0,0,0,3.7,3.73v3.5a.764.764,0,0,0,.772.773H14.16a.785.785,0,0,0,.8-.773V3.73a.785.785,0,0,0-.8-.773Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatalogProducts);
export default __webpack_public_path__ + "static/media/catalog-products.04e60f4a069db33964501014d4839192.svg";
export { ForwardRef as ReactComponent };